import React from "react";

export const DisclosureBanner = ({ variant = "top" }) => {
    return (
        <div
            data-testid={`disclosure-banner-${variant}`}
            style={{
                background: "var(--brr-disclosure-bg)",
                color: "var(--brr-disclosure-text)",
            }}
            className="w-full text-[11px] sm:text-xs tracking-[0.12em] uppercase text-center py-2 px-4 font-medium"
        >
            <span className="opacity-90">Advertisement</span>
            <span className="mx-2 opacity-50">·</span>
            <span className="opacity-90">
                Affiliate Disclosure — This is an advertorial. We may earn a
                commission from qualifying purchases made through links on this
                page.
            </span>
        </div>
    );
};
